import React, { useState } from 'react';
import { useParams, Link } from 'react-router';
import { motion, AnimatePresence } from 'framer-motion';
import AnimacionPagina from '../componentes/AnimacionPagina';
import styled from 'styled-components';
import Header from '../componentes/Header';
import WhatsAppShareButton from '../componentes/WhatsAppShareButton';
import BtnVolverAnim from '../elementos/BtnVolverAnim';
import productosTejidosExclusivos from '../data/todosLosProductos/productosTejidosExclusivos';
import WhatsAppContact from '../componentes/WhastsAppContact';
import Footer from '../componentes/Footer';


import {FichaProducto, Galeria, MotionImagen, Flecha, Miniaturas, Miniatura} from '../elementos/GaleriaStyles'

const DetallesTejidosExclusivos = () => {
  const { slug } = useParams();
  const producto = productosTejidosExclusivos.find(
    p => p.slug === slug
  );

  const [indiceSeleccionado, setIndiceSeleccionado] = useState(1);
  const [animando, setAnimando] = useState(false);
  

  if (!producto) return <h2>Producto no encontrado</h2>;

  const imagenActual = producto.images[indiceSeleccionado];
  const imagenesDeColores = producto.images.slice(1);

  const cambiarImagen = (index) => {
    if (index >= 0 && index < producto.images.length) {
      setAnimando(true);
      setTimeout(() => {
        setIndiceSeleccionado(index);
        setAnimando(false);
      }, 50);
    }
  };

  return (
    <>
    <Header />
    <AnimacionPagina>
        <FichaProducto>
        <h1>{producto.nombre}</h1>
        <h3>{producto.categoria}</h3>
        <p>Ancho: <b>{producto.ancho}</b></p>
        <WhatsAppContact 
            phoneNumber="524773059542" 
            defaultMessage='Quiero más información de los tejidos excluisvos'
            messageView ='¿Quieres conocer más sobre esta tela?'
        />
      <Galeria>
        <Flecha className='flechaBack' onClick={() => cambiarImagen(indiceSeleccionado - 1)}>&larr;</Flecha>
        <AnimatePresence mode="wait">
          <MotionImagen
            key={imagenActual}
            src={imagenActual}
            alt="Imagen seleccionada"
            initial={{ opacity: .5, scale: .5 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0 }}
          />
        </AnimatePresence>
        <Flecha className='flechaSig' onClick={() => cambiarImagen(indiceSeleccionado + 1)}>&rarr;</Flecha>
      </Galeria>

     
      <Miniaturas> 
        <motion.div
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.7 }}
        >
      </motion.div>
        
        {producto.colores.map((color, i) => (
        <motion.div
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.7 }}
          >
          <Miniatura
            key={color}
            activa={indiceSeleccionado === i + 1}
            onClick={() => cambiarImagen(i + 1)}
          >
            <img src={imagenesDeColores[i]} alt={color} />
            <span>{color}</span>
          </Miniatura>
        </motion.div>
          
        ))}
      </Miniaturas>
          <BtnVolverAnim Ref='/tejidos-exclusivos'/>
          <WhatsAppShareButton message="Te comparto esta tela exclusiva" />
      </FichaProducto>
      <Footer />
    </AnimacionPagina>
    </>
    
  );
};


export default DetallesTejidosExclusivos;